import React from 'react';
import styled from 'styled-components';
import { fontFamily, fontSize } from '../../../../../../constants/text';
import { colors } from '../../../../../../constants/colors';

const Root = styled.div.withConfig({ componentId: 'sc-dlc7ll-0' })`
  font-family: ${fontFamily.bold};
  color: ${colors.squid};
  font-size: ${fontSize.extraLarge};
  padding: 24px 0 24px 0;
`;

type OwnProps = {
  title?: string;
};

// @ts-expect-error ts-migrate(2456) FIXME: Type alias 'Props' circularly references itself.
type Props = OwnProps & typeof Header.defaultProps;

// @ts-expect-error ts-migrate(7022) FIXME: 'Header' implicitly has type 'any' because it does... Remove this comment to see the full error message
const Header = ({ title }: Props) => <Root>{title}</Root>;

Header.defaultProps = {
  title: 'Book a visit',
};

export default Header;
